import { mapMutations } from 'vuex'
import * as T from '@store/types'
import { watchDevServer } from '../utils/dev-component'

export default {
    computed: {
        isDevComponent() {
            return this.$route.query?.dev === 'component'
        },
    },
    created() {
        if (this.isDevComponent) {
            this.watchMeta()
        }
    },
    provide() {
        return {
            $isDevComponent: this.isDevComponent,
        }
    },
    methods: {
        ...mapMutations({
            updetaLocalComponents: T.UPDATE_LOCAL_COMPONENT,
        }),
        watchMeta() {
            const { devComponentHost, devComponentPort } = this.$store.state.modeling
            watchDevServer('__paas-update-meta', { host: devComponentHost, port: devComponentPort }, data => {
                this.updetaLocalComponents(data)
            })
        },
    },
}
